const animationEmbedRevealEffect = () => {
	const videos = gsap.utils.toArray('.wp-block-embed');

	if (videos.length) {
		videos.forEach((video) => {
			const v = gsap.utils.selector(video);

			gsap.set(v('.wp-block-embed__wrapper iframe'), {
				x: -200,
				scale: 0.7,
			});

			ScrollTrigger.create({
				trigger: video,
				onEnter: () =>
					gsap.to(v('.wp-block-embed__wrapper iframe'), {
						x: 0,
						scale: 1
					}),
			});
		});
	}
};

export default animationEmbedRevealEffect;
